// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  getAnalytics,
  logEvent as analyticsLogEvent,
} from "firebase/analytics";
import { getDownloadURL, getStorage, ref } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Conditionally initialize analytics in production
function enableAnalytics() {
  if (import.meta.env.PROD) {
    const analytics = getAnalytics(app);
    return analytics;
  } else {
    console.info(`Analytics not enabled in ${import.meta.env.MODE} mode.`);
    return null;
  }
}

const analytics = enableAnalytics();

// Initialize Firebase Storage
const storage = getStorage(app);
// Function to get image URL from Firebase Storage
export async function getImageURL(path: string): Promise<string> {
  try {
    const storageRef = ref(storage, path);
    return await getDownloadURL(storageRef);
  } catch (error) {
    console.error("Error fetching image URL:", error);
    return "/fallback-image.png"; // Imagem de fallback caso ocorra erro
  }
}

export async function getDocumentURL(path: string): Promise<string> {
  try {
    const storageRef = ref(storage, path);
    return await getDownloadURL(storageRef);
  } catch (error) {
    console.error("Error fetching image URL:", error);
    return "/example.pdf";
  }
}

export { storage };

export function logEvent(
  eventName: string,
  eventParams?: { [key: string]: any },
) {
  if (analytics) {
    analyticsLogEvent(analytics, eventName, eventParams);
  } else if (import.meta.env.DEV) {
    console.info(`Disabled on development:`, eventName, eventParams);
  }
}

logEvent("notification_received");
logEvent("select_content");
logEvent("screen_view");
